import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromFloorMap from './reducers/floor-map.reducer';
import * as fromFloorMapFilter from './reducers/map-filter.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FloorMapEffects } from './effects/floor-map.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('floorMap', fromFloorMap.reducer),
    StoreModule.forFeature('mapFilter', fromFloorMapFilter.reducer),
    EffectsModule.forFeature([FloorMapEffects])
  ]
})
export class FloorMapModule { }
